export default function (newItem, itemInCache) {
    var keys = Object.keys(itemInCache);
    keys.forEach(function (key) {
        // For each property that exists on the item in the cache, set it on the new item if it doesn't already have it.
        if (!newItem[key]) {
            newItem[key] = itemInCache[key];
        }
    });
}
//# sourceMappingURL=preserveItemDataInCache.js.map